import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { CommonLifeLinkProps } from '../CommonLifeLink/CommonLifeLink.types';
import LifeLinkLoaderComponent from '../CommonLifeLink/LifeLinkLoaderComponent';
import { StDTPGridContainer } from '../shared/Container/Container.styles';
import { CommonLifeLinkRequest } from '../../types/LifeLink';
import { commonPostToLifeLink } from '../../lib/utils/axiosFetcher';
import React from 'react';

const CommonLifeLink = (props: CommonLifeLinkProps): JSX.Element => {
  const router = useRouter();

  const getPostToLLPayload = (): CommonLifeLinkRequest => {
    return {
      lifeLinkToken: router.query?.uToken as string,
      lifeLinkApiUrl: props.fields.lifeLinkAPIURL?.value || '',
      lifeLinkUserName: props.fields.llUserName?.value || '',
      lifeLinkPassword: props.fields.llPassword?.value || '',
      websiteTheme: props.fields.websiteTheme?.value || '',
    };
  };

  const [message, setMessage] = useState(
    <b>
      <RichText id="ll-heading" field={props.fields.heading} />
      <LifeLinkLoaderComponent></LifeLinkLoaderComponent>
    </b>
  );

  useEffect(() => {
    const handleLifeLink = async () => {
      const payload = getPostToLLPayload();
      try {
        const dapApiLLResponse = await commonPostToLifeLink(payload);
        if (
          dapApiLLResponse !== null &&
          dapApiLLResponse.lifeLinkUrl != null &&
          dapApiLLResponse.lifeLinkUrl !== ''
        ) {
          window.location.href = dapApiLLResponse.lifeLinkUrl;
          return; // Ensure a return statement here
        } else {
          return setMessage(
            <b>
              <RichText id="ll-heading" field={props.fields.errorMessage} />
            </b>
          );
        }
      } catch (e: any) {
        // Handle error
        return setMessage(
          <b>
            <RichText id="ll-heading" field={props.fields.errorMessage} />
          </b>
        );
      }
    };

    if (router?.isReady) {
      handleLifeLink();
    }
  }, [router?.isReady]);

  if (!props?.fields) return <></>;

  return (
    <StDTPGridContainer id="common-lifelink" className="ui-common-lifelink">
      <Box style={{ textAlign: 'center' }}>{message}</Box>
    </StDTPGridContainer>
  );
};

export default CommonLifeLink;
